export interface ScopedApiErrorMessages {
  [scope: string]: {
    [errorKey: string]: string;
  };
}

export const apiErrorMessages: ScopedApiErrorMessages = {
  auth: {
    default: $localize`:@@auth.default:Something went wrong. Please try again.`,
  },
  reset_password: {
    required_fields_missing: $localize`:@@reset_password.required_fields_missing:Token and password are required.`,
    invalid_token: $localize`:@@reset_password.invalid_token:The password reset link has expired or already been used.`,
    password_policy_violation: $localize`:@@reset_password.password_policy_violation:The password does not meet the security requirements.`,
    user_not_found: $localize`:@@reset_password.user_not_found:The user account associated with this token no longer exists.`,
    internal_server_error: $localize`:@@reset_password.internal_server_error:An unexpected error occurred.`,
    default: $localize`:@@auth.default:Something went wrong. Please try again.`,
  },
  email_change: {
    email_missing: $localize`:@@email_change.email_missing:Missing email in request.`,
    email_invalid_format: $localize`:@@email_change.email_invalid_format:Invalid email format.`,
    third_party_login_only: $localize`:@@email_change.third_party_login_only:Email change is not available for third-party login methods.`,
    email_change_not_allowed: $localize`:@@email_change.email_change_not_allowed:Email change not allowed due to account linking restrictions.`,
    email_already_exists: $localize`:@@email_change.email_already_exists:Email already exists with another user.`,
    internal_server_error: $localize`:@@email_change.internal_server_error:An unexpected error occurred.`,
    default: $localize`:@@auth.default:Something went wrong. Please try again.`,
  },
  update_password: {
    required_fields_missing: $localize`:@@update_password.required_fields_missing:Missing required fields. Both oldPassword and newPassword are required.`,
    no_password_login_method: $localize`:@@update_password.no_password_login_method:You don't have a password set up. Please use 'set password' instead.`,
    password_same_as_old: $localize`:@@update_password.password_same_as_old: New password must be different from current password.`,
    password_policy_violation: $localize`:@@update_password.password_policy_violation: Password policy violation.`,
    incorrect_password: $localize`:@@update_password.incorrect_password: The current password is incorrect.`,
    user_not_found: $localize`:@@update_password.user_not_found: User not found.`,
    internal_server_error: $localize`:@@update_password.internal_server_error: An unexpected error occurred.`,
    default: $localize`:@@auth.default:Something went wrong. Please try again.`,
  },
  set_new_password: {
    password_missing: $localize`:@@set_new_password.password_missing: Missing password in request.`,
    password_already_set: $localize`:@@set_new_password.password_already_set: User already has a password set.`,
    no_email_found: $localize`:@@set_new_password.no_email_found: No email found for user.`,
    password_policy_violation: $localize`:@@set_new_password.password_policy_violation: Password policy violation.`,
    user_not_found: $localize`:@@set_new_password.user_not_found: User not found.`,
    internal_server_error: $localize`:@@set_new_password.internal_server_error: An unexpected error occurred.`,
    default: $localize`:@@auth.default:Something went wrong. Please try again.`,
  },
};
